import paths from '../../constants/paths';

const SET_COMPANY = 'set_company';

const state = () => ({
  company: null,
});

const actions = {
  fetchCurrentCompany ({ commit, rootState }) {
    const user = rootState.account.user;
    const currentCompany = user.currentCompany;

    if (currentCompany !== null) {
      return this.$getDataProvider(paths.companies)
        .fetchObject('', { uuid: currentCompany })
        .then((response) => commit(SET_COMPANY, response.item));
    }

    return Promise.resolve('Customer has no company');
  },
};

const mutations = {
  [SET_COMPANY] (state, company) {
    state.company = company;
  },
};

const getters = {
  getCompany (state) {
    return state.company;
  },
};

export default {
  state,
  actions,
  mutations,
  getters,
};
